import { abWrapPageElement } from './abWrapPageElement';
import { abWrapRootElement } from './abWrapRootElement';

export const wrapPageElement = abWrapPageElement;
export const wrapRootElement = abWrapRootElement;
